import type { IconNode } from '../types';

/**
 * @name letter-spacing
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTRIOSIgLz4KICA8cGF0aCBkPSJNMjEgM3YxOCIgLz4KICA8cGF0aCBkPSJNMyAzdjE4IiAvPgogIDxwYXRoIGQ9Im04IDE2IDMuNDUzLTcuNjQ4YS42LjYgMCAwMTEuMDk0LjAwMUwxNiAxNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/letter-spacing
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LetterSpacing: IconNode = [
  ['path', { d: 'M15 14H9' }],
  ['path', { d: 'M21 3v18' }],
  ['path', { d: 'M3 3v18' }],
  ['path', { d: 'm8 16 3.453-7.648a.6.6 0 011.094.001L16 16' }],
];

export default LetterSpacing;
